import cmsApi from '@src/services/cms-api';

const Service = {
  getList: () => cmsApi.getArticleList({ categoryId: 1112, pageNum: 1, pageSize: 100, moreInfo: 1,api:"//www.amazingseasun.com/api.php" })
};
export default Service;
